import { render, staticRenderFns } from "./donate.page.vue?vue&type=template&id=653fa68d&scoped=true&"
import script from "./donate.page.vue?vue&type=script&lang=js&"
export * from "./donate.page.vue?vue&type=script&lang=js&"
import style0 from "./donate.page.vue?vue&type=style&index=0&id=653fa68d&prod&scoped=true&lang=css&"
import style1 from "./donate.page.vue?vue&type=style&index=1&id=653fa68d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653fa68d",
  null
  
)

export default component.exports